import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/redux-store";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { siteColors } from "./common/config";
import "./i18n";

const theme = createTheme({
  palette: {
    primary: {
      main: siteColors?.main?.primary,
      contrastText: "#fff",
    },
  },
});

const container = document?.getElementById?.("root");
const root = container ? createRoot?.(container) : null;

root?.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// Можно передать функцию, если нужно что-то логировать
reportWebVitals?.();
